import {DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS} from '../../WorkspaceDrawer/Settings/runLinePlots/maxRunDefaults';
import {type RunsLinePlotConfig} from '../types';
import {serverFlagNoNonMonotonicFallback} from './../../../config';

export function configSupportsBucketing(
  config: {
    groupAgg?: RunsLinePlotConfig['groupAgg'];
    groupArea?: RunsLinePlotConfig['groupArea'];
    isMonotonic?: boolean;
    isInReport?: boolean;
    xAxis?: RunsLinePlotConfig['xAxis'];
    limit?: number;
    allowFullFidelityRanges?: boolean;
  },
  /**
   * This is an override which is added because non-monotonic detection is broken in V2 and forcing customers back to sampling.
   * https://weightsandbiases.slack.com/archives/G01BLMX3H61/p1728491743432009
   */
  serverFlag = serverFlagNoNonMonotonicFallback
) {
  const warnings = [];

  if (
    config.isInReport &&
    config.limit &&
    config.limit > DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS
  ) {
    warnings.push(
      `max runs limit over ${DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS}`
    );
  }

  /**
   * We don't support samples in full fidelity mode, and only support stderr/stddev if the ramp flag is enabled
   */
  if (
    config.groupArea === 'samples' ||
    (!config.allowFullFidelityRanges &&
      ['stderr', 'stddev'].includes(config.groupArea ?? ''))
  ) {
    warnings.push('unsupported group aggregation');
  }

  // The app now supports using _absolute_runtime as a valid x-axis, however, this won't be deployed
  // in server environments yet. So for now we'll remove this from SAAS in the config defaults and
  // and then remove it in the following server release
  if (
    !config.isMonotonic &&
    config.xAxis !== '_absolute_runtime' &&
    !serverFlag()
  ) {
    warnings.push('non-monotonic x-axis');
  }

  return warnings;
}
